export class ChartTooltip {
  private readonly element = document.createElement("div");
  constructor(private readonly host: HTMLElement) {
    this.element.className = "chart-tooltip"; this.element.hidden = true; this.element.setAttribute("role", "tooltip"); host.append(this.element);
  }
  show(target: Element, text: string): void {
    this.element.textContent = text; this.element.hidden = false;
    const box = (target as HTMLElement).getBoundingClientRect(); const parent = this.host.getBoundingClientRect();
    this.element.style.left = `${box.left - parent.left + box.width / 2}px`; this.element.style.top = `${box.top - parent.top - 8}px`;
  }
  hide(): void { this.element.hidden = true; }
  destroy(): void { this.element.remove(); }
}
